import type { ITableSort } from "app/components/React/Table/types";
import { DefaultFetchService } from "app/services/fetchService";

export const resolveExcelLink = (
    excelEndpoint: string,
    filtersStateObject: Record<string, unknown>,
    sort: ITableSort,
): string => {
    const fetcherService = DefaultFetchService.getInstance();
    const urlParams = {
        ...filtersStateObject,
        orderBy: `${sort.field}${sort.sortDirection === "desc" ? ` ${sort.sortDirection}` : ""}`,
    };
    return `/${excelEndpoint}?${fetcherService.requestParams(urlParams)}`;
};
